import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import AboutUs from '@/views/AboutUs'
import Details from '@/views/Details'
import ParcelTracking from '@/views/ParcelTracking'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        title: 'Printbelletrack - the Best Logistics Service Provider - Printbelletrack'
      }
    },
    {
      path: '/home',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Track & Trace Platform | Printbelletrack - PrintbelleExpress'
      }
    },
    {
      path: '/parcelTracking',
      name: 'ParcelTracking',
      component: ParcelTracking,
      meta: {
        title: 'Tracking Results | Printbelletrack - PrintbelleExpress'
      }
    },
    {
      path: '/Track/Detailing',
      name: 'Detailing',
      component: Details,
      meta: {
        title: 'Tracking Details | Printbelletrack - PrintbelleExpress'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js